import React, { memo, useState } from "react";
import {
  Box,
  Divider,
  IconButton,
  Popover,
  Tooltip,
  Typography,
} from "@mui/material";
import HistoryIcon from "@mui/icons-material/History";

const displayValue = (value) => {
  if (value === null || value === undefined || value === "") {
    return "—";
  }

  return String(value);
};

const CellValueHistory = memo(function CellValueHistory({
  mapping,
  currentValue,
  role,
}) {
  const [anchorEl, setAnchorEl] = useState(null);

  // Display history only for Processor-edited fields in investigatorValidatior.
  const shouldShowHistory =
    role === "investigatorValidatior" && mapping?.is_value_updated === true;

  if (!shouldShowHistory) return null;

  const previousValue = mapping?.ocrExtractedValueBeforeProChanges;
  const open = Boolean(anchorEl);

  return (
    <>
      <Tooltip title="View previous and current values" placement="left">
        <IconButton
          size="small"
          aria-label="View value history"
          onClick={(event) => {
            event.stopPropagation();
            setAnchorEl(event.currentTarget);
          }}
          sx={{
            position: "absolute",
            padding: "0 !important",
            height: "15px",
            width: "15px",
            cursor: "pointer",
            bottom: "0 !important",
            border: "0 !important",
            backgroundColor: "transparent",
            top: "20px !important",
          }}
        >
          <HistoryIcon
            sx={{
              fontSize: 10,
              height: "15px !important",
              width: "15px !important",
            }}
          />
        </IconButton>
      </Tooltip>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "center",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "right",
        }}
        slotProps={{
          paper: {
            sx: {
              width: 260,
              p: 1.5,
              borderRadius: 2,
            },
          },
        }}
      >
        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          Field Change History
        </Typography>

        <Typography variant="caption" color="text.secondary">
          Previous OCR value
        </Typography>

        <Box
          sx={{
            my: 0.5,
            mb: 1.5,
            p: 1,
            borderRadius: 1,
            bgcolor: "#F5F5F5",
            overflowWrap: "anywhere",
          }}
        >
          <Typography variant="body2">{displayValue(previousValue)}</Typography>
        </Box>

        <Divider sx={{ mb: 1.5 }} />

        <Typography variant="caption" color="text.secondary">
          Current value
        </Typography>

        <Box
          sx={{
            mt: 0.5,
            p: 1,
            borderRadius: 1,
            bgcolor: "#E8F5E9",
            color: "#2E7D32",
            overflowWrap: "anywhere",
          }}
        >
          <Typography variant="body2" fontWeight={600}>
            {displayValue(currentValue)}
          </Typography>
        </Box>
      </Popover>
    </>
  );
});

export default CellValueHistory;
